import API from '../../../../../services/api';

export const API_DEVOLUCIONES = {
    getDevoluciones: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/devoluciones' + pagination + searcher).then(res => res.data);
    },
    newDevolucion: async (devolucion) => {
        return API.post('/devoluciones', devolucion).then(res => res.data);
    }
}